<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-select :items="missionTimeRangeOptions" label="Quest Time" dense outlined v-model="selectedMissionTimeRange" :menu-props="{ offsetY: true }" @change="onMissionTimeRangeFilterChange" />
      </v-col>
      <v-col cols="12" md="4">
        <v-select :items="missionStateOptions" label="Quest Status" dense outlined v-model="selectedMissionState" :menu-props="{ offsetY: true }" @change="onMissionStateFilterChange" />
      </v-col>
      <v-col cols="12" md="4">
        <v-row justify="center" align="center">
          <div class="mt-2">
            {{ activeMissionAmount }} active
            <span v-if="activeMissionAmount > 1">quests</span>
            <span v-else>quest</span>
          </div>
          <v-divider vertical class="mx-4 mt-2" />
          <div class="mt-2">
            {{ verifiedMissionAmount }} completed
            <span v-if="verifiedMissionAmount > 1">quests</span>
            <span v-else>quest</span>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "MissionListFilters",

    data() {
      return {
        missionTimeRangeOptions: [
          {
            text: "All",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: "",
            },
          },
          {
            text: "Yesterday",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(1),
            },
          },
          {
            text: "Last 2 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(2),
            },
          },
          {
            text: "Last 3 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(3),
            },
          },
          {
            text: "Last 4 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(4),
            },
          },

          {
            text: "Last 5 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(5),
            },
          },
          {
            text: "Last 6 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(6),
            },
          },
          {
            text: "Last 7 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(7),
            },
          },
        ],
        selectedMissionTimeRange: {},
        missionStateOptions: [
          {
            text: "All",
            value: { state: "open,verified,completed" },
          },
          {
            text: "Open",
            value: { state: "open,completed" },
          },
          {
            text: "Completed",
            value: { state: "verified" },
          },
        ],
        selectedMissionState: {},
      };
    },

    computed: {
      userId() {
        return this.$route.params.id ? this.$route.params.id : this.$store.getters.userInfo.id;
      },
      activeMissionAmount() {
        return this.$store.getters.filterMissionsByKidId(this.userId).filter((mission) => !mission.verified).length;
      },
      verifiedMissionAmount() {
        return this.$store.getters.filterMissionsByKidId(this.userId).filter((mission) => mission.verified).length;
      },
    },

    methods: {
      onMissionTimeRangeFilterChange() {
        this.$store.commit("setMissionFilters", {
          timeRange: this.selectedMissionTimeRange,
        });

        //reset to first page
        this.$store.commit("setMissionListPaginationInfo", {
          pageSize: 10,
          currentPage: 1,
        });

        this.$emit("fetch-missions");
      },

      onMissionStateFilterChange() {
        this.$store.commit("setMissionFilters", {
          status: this.selectedMissionState.state,
        });

        //reset to first page
        this.$store.commit("setMissionListPaginationInfo", {
          pageSize: 10,
          currentPage: 1,
        });

        this.$emit("fetch-missions");
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/MissionListFilters.vue